// extracted by mini-css-extract-plugin
module.exports = {"input-wrapper":"BaseCheckbox_input-wrapper_2HDbB"};